export const logo = 'https://tse1.mm.bing.net/th?id=OIP.hTenU9IcDJAr2GvucSpcuAHaEc&pid=Api&P=0&h=220.jpg';
